import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { SharedService } from '../../shared/shared.service';
import { NetworkingService } from '../../shared/networking.service';

@Injectable()
export class AgencyService {
	public agenciesData: Object;
	public agentData: Object;
	private agencyDetails: Object;
	private agentDetails: Object;
	private agentCityCode: string = "";
	private agencyCityCode: string = "";

	constructor(private sharedService: SharedService, private networkingService: NetworkingService) {
		this.agenciesData = this.sharedService.getAgencyInfoDetails();
		this.agentData = this.sharedService.getAgentInfoDetails();
	}

	submitFormDetails(formDetails, formType): Observable<any> {
		if (formType == 'createAgency' || formType == 'modifyAgency') {
			if (formDetails && formDetails.city) {
				if (formDetails.city.indexOf("(")>0)
				this.agencyCityCode = formDetails.city.substring(formDetails.city.indexOf("(") + 1, formDetails.city.indexOf(")"));
				else 
				this.agencyCityCode = formDetails.city;
			}
			
			this.agencyDetails = {
				"iataNumber": formDetails.iataNumber,
				"agencyName": formDetails.agencyName,
				"agencyAdress1": formDetails.address1,
				"agencyAdress2": formDetails.address1,
				"agencyCity": this.agencyCityCode,
				"agencyState": formDetails.state,
				"agencyPostalCode": formDetails.zipCode,
				"agencyCountry": formDetails.country,
				"contactName": formDetails.contactName,
				"accountFirstName": formDetails.firstname,
				"accountLastName": formDetails.lastname,
				"accountEmail": formDetails.accountEmail,
				"contactInfos": [
					{
						"OriginalContactFieldValue": formDetails.phone,
						"contactField": formDetails.phone,
						"contactType": "WorkPhone",
						"preferredContactMethod": "true",
						"countryCode": formDetails.phoneCode,
						"phoneNumber": formDetails.phone

					}
				],
				//	"accountUserName": formDetails.userName,
				"agencyStatus": formDetails.agencyStatus,
				//"recieptOption":formDetails.recieptOption

			}
			if (formType == 'createAgency') {
				return this.networkingService.post('/agency/create-agency', this.agencyDetails)
					.map(
						response => {
							return response;
						},
						error => error
					);
			} else if (formType == 'modifyAgency') {
				return this.networkingService.put('/agency/modify-agency', this.agencyDetails)
					.map(
						response => {
							return response;
						},
						error => error
					);
			}
		} else if (formType == 'createAgent' || formType == 'modifyAgent') {
			if (formDetails && formDetails.city) {
			if (formDetails.city.indexOf("(")>0)
				this.agentCityCode = formDetails.city.substring(formDetails.city.indexOf("(") + 1, formDetails.city.indexOf(")"));
				else 
				this.agentCityCode = formDetails.city;
			}
			this.agentDetails = {
				"actionType": 0,
				"iataNumber": formDetails.iataNumber,
				"status": formType == 'createAgent' ? 1 : formDetails.agencyStatus == 'active' ? 1 : 0,
				"agentUsername": formDetails.userId || formDetails.firstname,
				"agentFirstName": formDetails.firstname,
				"agentLastName": formDetails.lastName,
				"agentAddress1": formDetails.address1,
				"agentAddress2": formDetails.address2,
				"agentCity": this.agentCityCode,
				"agentState": formDetails.state,
				"agentPostalCode": formDetails.zipCode,
				"agencyCountry": formDetails.country,
				"agentEmail": formDetails.accountEmail,
				"agentDefaultRole": "TA_ADMIN",
				"contactInfos": [{
					"id": formDetails.phone,
					"contactField": formDetails.phone,
					"contactType": "WorkPhone",
					"preferredContactMethod": "true",
					"countryCode": formDetails.phoneCode,
					"phoneNumber": formDetails.phone
				}],
				"languageCode": " en"
			}
			if (formType == 'createAgent') {
				return this.networkingService.post('/agent/create-agent', this.agentDetails)
					.map(
						response => {
							return response;
						},
						error => error
					);
			} else if (formType == 'modifyAgent') {
				return this.networkingService.put('/agent/modify-agent', this.agentDetails)
					.map(
						response => {
							return response;
						},
						error => error
					);
			}
		}
	}

	formErrors = {
		'iataNumber': '',
		'agencyName': '',
		'userName': '',
		'address1': '',
		'address2': '',
		'city': '',
		'state': '',
		'zipCode': '',
		'country': '',
		'contactName': '',
		'accountEmail': '',
		'phone': '',
		'phoneCode': '',
		'fax': '',
		'firstname': '',
		'lastName': '',
		'lastname': '',
		//'userId': ''
	};

	validationMessages = {
		'iataNumber': {
			'required': 'IATA Number is required',
			'isNumeric': 'IATA Number should be numeric',
			'noWhitespace': 'IATA Number is required',
			'isValidLength':'Invalid IATA Number'
		},
		'agencyName': {
			'required': 'Agency Name is required',
			'noWhitespace': 'Agency Name is required'
		},
		'userName': {
			'required': 'User Name is required',
			'noWhitespace': 'User Name is required'
		},
		'address1': {
			'required': 'Address is required',
			'noWhitespace': 'Address is required'
		},
		'address2': {
			'required': 'Address2 is required',
			'noWhitespace': 'Address2 is required'
		},
		'city': {
			'required': 'City is required',
			'noWhitespace': 'City is required'
		},
		'state': {
			'required': 'State is required',
			'noWhitespace': 'State is required'
		},
		'zipCode': {
			'isNumeric': 'Postal Code should be numeric',
			'required': 'ZipCode is required',
			'noWhitespace': 'White Space not allowed'
		},
		'country': {
			'required': 'Country is required',
			'noWhitespace': 'Country is required'
		},
		'contactName': {
			'required': 'Contact Name is required',
			'noWhitespace': 'Contact Name is required'
		},
		'accountEmail': {
			'required': 'Email is required',
			'isValidEmail': 'Invalid Email address',
			'noWhitespace': 'Email is required'
		},
		'phone': {
			'required': 'Phone number is required',
			'isNumeric': 'Enter valid phone number',
			'noWhitespace': 'Phone number is required',
			'inValidNumber': 'Invalid phone number'
		},
		'phoneCode': {
			'required': 'Country is required',
		},
		'fax': {
			'isNumeric': 'Fax should be numeric'
		},
		'firstname': {
			'required': 'First Name is required',
			'noWhitespace': 'First Name is required'
		},
		'lastName': {
			'required': 'Last Name is required',
			'noWhitespace': 'Last Name is required'
		},
		'lastname': {
			'required': 'Last Name is required',
			'noWhitespace': 'Last Name is required'
		},
		// 'userId' : {
		// 	'required': 'User Name is required',
		// 	'noWhitespace': 'User Name is required'
		// }
	};
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/shared/agency.service.ts